export default {"src":"/_next/static/media/HyperLogoText.9bcbf48a.svg","height":145,"width":400};